import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie";
import { AuthToken } from "../../model/authToken.model";
import { Observable, Subject } from "rxjs";
const cookie_id = "auth-token";

@Injectable()
export class AuthCookie {
  public auth_token: string;

  set setAuthToken(value: any) {
    this.auth_token = value;
  }

  get getAuthToken(): any {
    return this.auth_token;
  }

  public auth_detail: AuthToken;

  set setAuthTokenDetail(value: any) {
    this.auth_detail = value;
  }

  get getAuthTokenDetail(): AuthToken {
    return this.auth_detail;
  }

  private AuthTokenSubject: Subject<AuthToken> = new Subject<AuthToken>();
  get AuthState() {
    return this.AuthTokenSubject.asObservable();
  }

  constructor(private _cookieService: CookieService) {}

  public getCookie() {
    // let auth_token_base64 = this._cookieService.get(cookie_id);
    // if (undefined !== auth_token_base64) {
    //   this.setAuthToken = JSON.parse(
    //     this.urlBase64Decode(auth_token_base64)
    //   ).Id;
    // } else {
    //   // need to be removed
    //   this.setAuthToken = JSON.parse(
    //     this.urlBase64Decode(this.configuration.token)
    //   ).Id;
    //   return this.configuration.token;
    // }
    return this._cookieService.get(cookie_id);
  }

  public remove() {
    this._cookieService.remove("auth-token");
  }

  public decodeCookie(cookie) {
    this.setAuthTokenDetail = <AuthToken>JSON.parse(
      this.urlBase64Decode(cookie)
    ); // parsing the token
    this.AuthTokenSubject.next(this.getAuthTokenDetail); // emit the auth token detail event
    return JSON.parse(this.urlBase64Decode(cookie));
  }

  public getTokenExpirationDate(data): Date {
    if (!data.hasOwnProperty("ExpiresAt")) {
      return null;
    }
    let date = new Date(data.ExpiresAt); // The 0 here is the key, which sets the date to the epoch
    //date.setUTCSeconds(data.ExpiresAt);
    return date;
  }

  public isTokenExpired(data, offsetSeconds?: number): boolean {
    let date = this.getTokenExpirationDate(data);
    offsetSeconds = offsetSeconds || 0;
    if (date == null) {
      return false;
    }

    return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
  }

  /**
   * Decodes a base 64 url into a string.
   *
   * @param {string} str - String to decode
   * @return {string}
   */
  public urlBase64Decode(str: string): string {
    let output = str.replace("-", "+").replace("_", "/");
    switch (output.length % 4) {
      case 0:
        break;
      case 2:
        output += "==";
        break;
      case 3:
        output += "=";
        break;
      default:
        throw "Illegal base64url string!";
    }

    return window.atob(output);
  }
}
